
class LocalStorage {
    public getItem(key: string): any {
        const data = localStorage.getItem(key);
        try {
            return JSON.parse(data);
        } catch (e) {
            return data;
        }
    }

    public setItem(key, value) {
        if (typeof value === "string") {
            localStorage.setItem(key, value);
        } else {
            localStorage.setItem(key, JSON.stringify(value))
        }
    }

    public removeItem(key) {
        localStorage.removeItem(key);
    }
}

export default new LocalStorage();
